import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './quickStart.intl.json';

export const useQuickStartIntl = () => useIntlModule(messages);
